import { ForwardedRef, forwardRef } from 'react'

function HeaderMenuButton(
  { onClick }: { onClick: () => void },
  ref: ForwardedRef<HTMLButtonElement>,
): React.ReactElement {
  return (
    <button className="absolute z-20 right-4 top-4 w-10 space-y-1.5" onClick={onClick} ref={ref}>
      <span className="h-1 block rounded-full bg-white" />
      <span className="h-1 block rounded-full bg-white" />
      <span className="h-1 block rounded-full bg-white" />
    </button>
  )
}

export default forwardRef(HeaderMenuButton)
